"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenu = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var theme_1 = require("./theme");
var DropdownMenu = function (props) {
    var wrapperRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (props.isOpen) {
            document.addEventListener("click", handleClickOutside, false);
        }
        else {
            document.removeEventListener("click", handleClickOutside, false);
        }
        return function () {
            document.removeEventListener("click", handleClickOutside, false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.isOpen]);
    var handleClickOutside = function (event) {
        if (props.isOpen &&
            wrapperRef.current &&
            !wrapperRef.current.contains(event.target)) {
            props.setOpen(false);
        }
    };
    return props.isOpen ? react_1.default.createElement(Wrapper, __assign({ ref: wrapperRef }, props)) : null;
};
exports.DropdownMenu = DropdownMenu;
var Wrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n  box-sizing: border-box;\n  width: min(300px, 90vh);\n  border: 1px solid ", ";\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  background: ", ";\n  padding: ", ";\n  z-index: 1;\n"], ["\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n  box-sizing: border-box;\n  width: min(300px, 90vh);\n  border: 1px solid ", ";\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  background: ", ";\n  padding: ", ";\n  z-index: 1;\n"])), theme_1.theme.colors.gray400, theme_1.theme.colors.white, theme_1.theme.space.small);
var templateObject_1;
